import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "../../util/DateConvertor";

export class UnionService {
    constructor() {
        this.httpiClient = new HttpClient()
    }

    getUnionList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpiClient.get(
                `funds`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getUnionBalance() {
        return new Promise((resolve, reject) => {
            this.httpiClient.get(
                `unions/balance`
            ).then(resolve).catch(reject)
        })
    }

    getUnionBasicInformation(fundId) {
        return new Promise((resolve, reject) => {
            this.httpiClient.get(
                `funds/${fundId}/union-financial-information`
            ).then(resolve).catch(reject)
        })
    }

    getUnionTransactionList(page, size, startDateValue, endDateValue, fundId) {
        return new Promise((resolve, reject) => {
            this.httpiClient.get(
                `unions/funds/${fundId}/transactions`,
                {
                    page,
                    size,
                    "start-date": startDateValue.length === 10 ? convertPersianDateToUniversalDate(startDateValue) : "",
                    "end-date": endDateValue.length === 10 ? convertPersianDateToUniversalDate(endDateValue) : "",
                }
            ).then(resolve).catch(reject)
        })
    }

    getUnitTransactionInfo(unionTransactionId) {
        return new Promise((resolve, reject) => {
            this.httpiClient.get(
                `unions/transactions/${unionTransactionId}`
            ).then(resolve).catch(reject)
        })
    }

    addNewTransaction(fundId, amount, date) {
        return new Promise((resolve, reject) => {
            this.httpiClient.post(
                `unions/funds/${fundId}/transactions`,
                {
                    amount,
                    date: convertPersianDateToUniversalDate(date)
                }
            ).then(resolve).catch(reject)
        })
    }

    updateTransaction(unionTransactionId, transactionValue, transactionDate) {
        return new Promise((resolve, reject) => {
            this.httpiClient.put(
                `unions/transactions/${unionTransactionId}`,
                {
                    "amount": transactionValue,
                    "date": convertPersianDateToUniversalDate(transactionDate)
                }
            ).then(resolve).catch(reject)
        })
    }


}